<ef-loading-container
    [observables]="[
        facilityAllocation$,
        facilityAllocationTypes$,
        showAllocationWarning$,
        allocationType$
    ]"
></ef-loading-container>
<ef-facility
    [items]="facilityAllocation$ | async"
    [facilityAllocationTypes]="facilityAllocationTypes$ | async"
    [showAllocationWarning]="showAllocationWarning$ | async"
    [allocationType]="allocationType$ | async"
    [selectedError]="selectedError"
    (ShowError)="ShowError.next($event)"
    (SaveFacilityAllocation)="onSaveFacilityAllocation($event)"
></ef-facility>
